import dayjs from 'dayjs';
import type { ChartDateBound } from './chartWhere.types';
import { isChartRelativeBound } from './chartWhere.types';

export function relativeDaysToYmd(relativeDays: number): string {
	return dayjs().startOf('day').add(relativeDays, 'day').format('YYYY-MM-DD');
}

export function calendarDaysPickMinusToday(ymd: string): number {
	const picked = dayjs(ymd.slice(0, 10)).startOf('day');
	const today = dayjs().startOf('day');
	if (!picked.isValid()) {
		return 0;
	}
	return picked.diff(today, 'day');
}

/** How one bound was stored in JSON (absolute string vs relative object). */
export function boundToUi(bound: unknown): { dateYmd: string; storedAsRelative: boolean } {
	if (bound === undefined || bound === null) {
		return { dateYmd: '', storedAsRelative: false };
	}
	if (typeof bound === 'string') {
		const t = bound.trim().slice(0, 10);
		return t ? { dateYmd: t, storedAsRelative: false } : { dateYmd: '', storedAsRelative: false };
	}
	if (isChartRelativeBound(bound)) {
		const ymd = relativeDaysToYmd(bound.relativeDays);
		return { dateYmd: ymd, storedAsRelative: true };
	}
	return { dateYmd: '', storedAsRelative: false };
}

export function uiSideToBound(dateYmd: string, useRelative: boolean): ChartDateBound | undefined {
	const ymd = dateYmd.trim().slice(0, 10);
	if (!ymd) {
		return undefined;
	}
	if (!useRelative) {
		return ymd;
	}
	const relativeDays = calendarDaysPickMinusToday(ymd);
	return { relativeDays };
}
